import { render } from "./CorComponent.vue?vue&type=template&id=5b05be3d"
import script from "./CorComponent.vue?vue&type=script&lang=js"
export * from "./CorComponent.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\myugcollege\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__